'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.distanceFromAnySide = exports.isVerticallyInline = exports.isOverlapping = exports.getLineFromRect = exports.getBoundingRect = exports.getFromWidthHeight = undefined;

var _line = require('./line');

var lineLib = _interopRequireWildcard(_line);

var _point = require('./point');

var pointLib = _interopRequireWildcard(_point);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// √
// Line lib
var getFromWidthHeight = exports.getFromWidthHeight = function getFromWidthHeight(_ref) {
    var x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height;
    return {
        left: x,
        right: x + width,
        top: y,
        bottom: y + height
    };
};

// √
var getBoundingRect = exports.getBoundingRect = function getBoundingRect(rect1, rect2) {
    return {
        left: Math.min(rect1.left, rect2.left),
        right: Math.max(rect1.right, rect2.right),
        top: Math.min(rect1.top, rect2.top),
        bottom: Math.max(rect1.bottom, rect2.bottom)
    };
};

// √
var getLineFromRect = exports.getLineFromRect = function getLineFromRect(rect, side) {
    return lineLib.getLine(pointLib.getPoint(side !== 'right' ? rect.left : rect.right, side !== 'bottom' ? rect.top : rect.bottom), pointLib.getPoint(side !== 'left' ? rect.right : rect.left, side !== 'top' ? rect.bottom : rect.top));
};

// √
var isOverlapping = exports.isOverlapping = function isOverlapping(rect1, rect2) {
    return (
        // horizontal overlap
        rect1.left < rect2.right && rect1.right > rect2.left &&
        // and vertical overlap
        rect1.top < rect2.bottom && rect2.top < rect1.bottom
    );
};

/**
 * Determines if two rectangles are overlapping horizontally.
 * This assumes the rectangles are flat along the x and y dimensions.
 */
var isVerticallyInline = exports.isVerticallyInline = function isVerticallyInline(rect1, rect2, threshold) {
    return lineLib.isOverlappingHorizontally(getLineFromRect(rect1, 'bottom'), getLineFromRect(rect2, 'bottom'), threshold);
};

/**
 * Determines the distance between two rectangles.
 */
// √
var distanceFromAnySide = exports.distanceFromAnySide = function distanceFromAnySide(rect1, rect2) {
    if (isOverlapping(rect1, rect2)) return 0;

    var mostLeftRect = rect1.left < rect2.left ? rect1 : rect2;
    var mostRightRect = rect1.right > rect2.right ? rect1 : rect2;
    // X difference
    var xDiff = mostRightRect.left - mostLeftRect.right;
    xDiff = Math.max(0, xDiff);

    var upperRect = rect1.top < rect2.top ? rect1 : rect2;
    var lowerRect = rect1.bottom > rect2.bottom ? rect1 : rect2;
    // X difference
    var yDiff = lowerRect.top - upperRect.bottom;
    yDiff = Math.max(0, yDiff);

    return Math.hypot(xDiff, yDiff);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/geometry/rect.js
// module id = 481
// module chunks = 0